import { memo, useRef, useState } from 'react';
import { Tooltip } from 'antd';
import styles from './TruncatedText.module.scss';

interface TruncatedTextProps {
  text: string;
  /** Opaque, smaller tooltip opening to the side, for dense menus. */
  compact?: boolean;
}

/** Ellipsised single-line text; the pill opens on hover only when clipped. */
const TruncatedText = ({ text, compact = false }: TruncatedTextProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (nextOpen: boolean) => {
    const el = textRef.current;
    setOpen(nextOpen && !!el && el.scrollWidth > el.clientWidth);
  };

  return (
    <Tooltip
      title={text}
      open={open}
      onOpenChange={handleOpenChange}
      arrow={false}
      destroyTooltipOnHide
      placement={compact ? 'right' : 'top'}
      overlayClassName={compact ? styles.compact : styles.pill}
    >
      <span className={styles.text} ref={textRef}>
        {text}
      </span>
    </Tooltip>
  );
};

export default memo(TruncatedText);
